<div *ngIf="!isButton" class="purchase-modal">
    <div class="modal-container">
        <div class="title-box">
            <div class="text-center cursor-pointer p-10" (click)="onOpen()">
                Comprar puntos <i class="fa fa-plus m-l-5"></i>
            </div>
        </div>
    </div>
</div>

<div *ngIf="isButton">
    <button class="btn btn-circle btn-primary btn-xsm" type="button" (click)="onOpen()">
        <i class="fa fa-plus"></i>
    </button>
    <label class="m-l-10 title">Comprar puntos</label>
</div>


<ng-template #purchaseModal let-modal>
    <div class="modal-body">

        <div>
            <button class="close" (click)="modal.dismiss()">
                <i class="fa fa-times m-t-5 m-r-10"></i>
            </button>
        </div>

        <div class="border-bottom">
            <div class="text-center">
                <i class="mdi mdi-send mdi-24px"></i>
            </div>
            <div class="text-center m-b-20">
                <span *ngIf="!showSummary">Paquete de puntos</span>
                <span *ngIf="showSummary">Resumen de la orden</span>
            </div>
        </div>

        <div *ngIf="!showSummary">

            <div *ngIf="products?.length">

                <div class="border-bottom p-t-20 p-b-10" *ngFor="let sourceItem of products">
                    <div class="d-flex flex-row justify-content-between">
                        <!-- Price -->
                        <div class="m-r-20 w-100">
                            <div class="custom-checkbox checkbox-primary">
                                <input id="{{sourceItem.id}}" name="radio-product" type="radio" value="{{sourceItem.id}}" [(ngModel)]="selectedProduct">
                                <label class="form-control-label label-text-md" for="{{sourceItem.id}}">
                                    {{sourceItem.price | currency: currencySymbol : 'symbol': '1.0'}}
                                </label>
                            </div>
                        </div>

                        <!-- Points -->
                        <div style="min-width: 90px;">
                            <span class="font-bold font-12">
                                + {{sourceItem.points}} pts
                            </span>
                        </div>
                    </div>
                </div>

                <div class="form-group text-center m-t-20">
                    <button class="btn btn-primary" type="button" (click)="onNext()" [disabled]="!selectedProduct">
                        Continuar
                    </button>
                </div>
            </div>

            <div *ngIf="!products?.length" class="m-l-15 text-left p-t-20 p-b-10">
                No hay paquete de puntos registrados.
            </div>
        </div>

        <div *ngIf="showSummary">

            <!-- Products -->
            <div class="border-bottom p-t-20 p-b-20" *ngFor="let sourceItem of model.products">
                <div class="d-flex flex-row justify-content-between">
                    <!-- Points -->
                    <div>
                        Paquete <span class="font-bold"> + {{sourceItem.points}} pts </span>
                    </div>
                    <!-- Price -->
                    <div>
                        {{sourceItem.price | currency: currencySymbol : 'symbol': '1.0'}}
                    </div>
                </div>
            </div>

            <!-- Points -->
            <div class="border-bottom p-t-20 p-b-20">
                <div class="d-flex flex-row justify-content-between">
                    <!-- Points -->
                    <div>
                        <div class="">
                            Total de puntos a recibir
                        </div>
                        <div class="text-purple" style="font-size: 0.8rem;">
                            {{model.points}} puntos
                        </div>
                    </div>
                    <!-- Edit -->
                    <!-- <div>
                        <button class="btn btn-outline-dark btn-sm" type="button" (click)="showSummary = false;">
                            Editar compra
                        </button>
                    </div> -->
                </div>
            </div>

            <!-- Totals -->
            <div class="border-bottom p-t-20 p-b-20">
                <!-- Subtotal -->
                <div class="d-flex flex-row justify-content-between">
                    <div>
                        Sub Total
                    </div>
                    <div>
                        {{model.subTotal | currency: currencySymbol : 'symbol': '1.0'}}
                    </div>
                </div>
                <!-- Total -->
                <div class="d-flex flex-row justify-content-between m-t-20">
                    <div class="font-bold">
                        Total
                    </div>
                    <div class="font-bold">
                        {{model.total | currency: currencySymbol : 'symbol': '1.0'}}
                    </div>
                </div>
            </div>

            <!-- Tarjeta -->
            <div *ngIf="currentMethod" class="border-bottom p-20 cursor-pointer" (click)="onOpenMethods(paymentMethodModal)">

                <div class="d-flex flex-row justify-content-between">
                    <!-- LOGO -->
                    <div class="text-left">
                        <img class="m-5-5" src="{{currentMethod.logoURL}}" width="36">

                        <span class="font-bold font-10">
                            {{currentMethod?.name ? currentMethod?.name : '**** **** ****' }} {{currentMethod.masked}}
                        </span>
                    </div>

                    <span class="font-bold font-18">
                        >
                    </span>
                </div>
            </div>

            <!-- Agregar tarjeta 
            <div *ngIf="!currentMethod" class="border-bottom p-20">
                <button class="btn btn-circle btn-outline-dark btn-sm" type="button" style="padding-top: 6px" (click)="onCreateCard(addPaymentMethodModal)">
                    <i class="fa fa-plus"></i>
                </button>
                <label class="m-l-10">Agregar nueva tarjeta</label>
            </div>
            -->
            <!-- Agregar Tarjeta -->
            <div *ngIf="!currentMethod" class="p-b-10 comment-row" (click)="onCreateCard(addPaymentMethodModal)">
                <div class="d-flex content-label-card text-center">
                    <div class="m-l-20 m-t-8">
                        <i class="mdi mdi-plus-circle-outline mdi-36px m-r-16"></i>
                    </div>
                    <div>
                        <label class="fond-card" style="margin-top: 16px;">
                            Agregar nueva tarjeta
                        </label>
                    </div>
                </div>
            </div>

            <!-- button submit -->
            <div class="d-flex-center p-20">
                <button [disabled]="!(model && currentMethod)" class="btn btn-primary" (click)="onPay()">Pagar</button>
            </div>
        </div>
    </div>
</ng-template>

<!-- Opciones de pago -->
<ng-template #paymentMethodModal let-modal>
    <div class="modal-body">

        <div>
            <button class="close" (click)="modal.dismiss()">
                <i class="fa fa-times m-t-5 m-r-10"></i>
            </button>
        </div>

        <div class="border-bottom">
            <div class="text-center">
                <i class="mdi mdi-credit-card-multiple mdi-24px"></i>
            </div>
            <div class="text-center m-b-20">
                Opciones de pago
            </div>
        </div>

        <!-- Tarjeta -->
        <div *ngFor="let sourceItem of methods">
            <div class="border-bottom p-20 cursor-pointer" (click)="onSelectMethod(sourceItem, modal)">

                <div class="d-flex flex-row justify-content-between">
                    <!-- LOGO -->
                    <div class="text-left">
                        <img class="m-5-5" src="{{sourceItem.logoURL}}" width="36">

                        <span class="font-bold font-10">
                            {{sourceItem?.name ? sourceItem?.name : '**** **** ****' }} {{sourceItem.masked}}
                        </span>
                    </div>
                </div>
            </div>
        </div>

        <!-- Agregar tarjeta -->
        <div class="p-20">
            <div class="p-b-10 comment-row" (click)="onCreateCard(addPaymentMethodModal)">
                <div class="d-flex content-label-card text-center">
                    <div class="m-l-20 m-t-8">
                        <i class="mdi mdi-plus-circle-outline mdi-36px m-r-16"></i>
                    </div>
                    <div>
                        <label class="fond-card" style="margin-top: 16px;">
                            Agregar nueva tarjeta
                        </label>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>


<!-- Agregar nueva tarjeta -->
<ng-template #addPaymentMethodModal let-modal>
    <div class="modal-body">

        <div>
            <button class="close" (click)="modal.dismiss()">
                <i class="fa fa-times m-t-5 m-r-10"></i>
            </button>
        </div>

        <div class="m-b-20 border-bottom">
            <div class="text-center">
                <i class="mdi mdi-send mdi-24px"></i>
            </div>
            <div class="text-center m-b-20">
                Agregar nueva tarjeta
            </div>
        </div>

        <!-- Formulario de tarjeta compartido: decide solo si muestra los campos de
             ONVO o los de Stripe según la pasarela del país -->
        <div class="m-b-20 p-20">
            <app-card-form [country]="country" (cardChange)="onCardChange($event)"></app-card-form>

            <div>
                <img src="assets/images/masterVisaStripe.png" height="28">
            </div>
        </div>

        <div class="d-flex-center">
            <button [disabled]="readonly || !newCard" (click)="onSaveCard(modal)"
                class="btn btn-primary btn-sm m-2">Agregar</button>
        </div>
    </div>
</ng-template>